"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var StyledDropdownButton_1 = __importDefault(require("containers/TableMaker/components/StyledDropdownButton"));
var DropdownMenu_1 = __importDefault(require("shared/components/DropdownMenu"));
var DropdownOption_1 = __importDefault(require("shared/components/DropdownMenu/DropdownOption"));
var constants_1 = require("../constants");
var hooks_1 = require("../hooks");
var ReactivateUserDropdown = function (_a) {
    var _b;
    var item = _a.item;
    var _c = __read(react_1.default.useState(null), 2), anchorEl = _c[0], setAnchorEl = _c[1];
    var _d = __read((0, hooks_1.useUpdateUser)(item.id), 2), userSubmitter = _d[0], isSubmitting = _d[1];
    var handleClick = function (event) { return setAnchorEl(anchorEl ? null : event.currentTarget); };
    var handleOnClose = function () { return setAnchorEl(null); };
    var accessLevel = ((_b = constants_1.ACC_LVL_PROPS_MAPPER[item.accessLevel || '']) === null || _b === void 0 ? void 0 : _b.title) || 'N/A';
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(StyledDropdownButton_1.default, __assign({ onClick: handleClick, isOpen: !!anchorEl }, { children: accessLevel })), (0, jsx_runtime_1.jsx)(DropdownMenu_1.default, __assign({ anchorEl: anchorEl, open: !!anchorEl, onClose: handleOnClose }, { children: (0, jsx_runtime_1.jsx)(DropdownOption_1.default, { title: "Re-activate user", titleColor: "green", description: "The user will regain access to Hudled as ".concat(accessLevel, "."), onClick: function () { return userSubmitter({ isSuspended: false }); }, disabled: isSubmitting, autoFocus: true }) }))] }));
};
exports.default = ReactivateUserDropdown;
